import { api } from './client'

/**
 * F-124 (TASK-0378, REQ-244-001): client di `SearchIndexController` (`/api/platform/search-index`, solo Admin).
 * Stato dell'indice di ricerca dedicato e richiesta di ricostruzione. Solo conteggi e date: nessun dato personale.
 */
export type SearchIndexStatusName = 'Spento' | 'InCostruzione' | 'Pronto' | 'Errore'

export interface SearchIndexStatus {
  available: boolean
  workerEnabled: boolean
  useForQueries: boolean
  /** Assenti quando `available` è false. */
  status?: SearchIndexStatusName
  usable?: boolean
  rowsByType?: Record<string, number>
  totalRows?: number
  lastFullRebuildAt?: string | null
  lastIncrementalAt?: string | null
  lagSeconds?: number | null
  maxLagMinutes?: number
  rebuildRequestedAt?: string | null
  lastError?: string | null
}

export interface SearchIndexRebuildResult {
  available: boolean
  workerEnabled: boolean
  rebuildRequestedAt?: string
}

export const SEARCH_ENTITY_LABELS: Record<string, string> = {
  customer: 'Clienti',
  contact: 'Contatti',
  lead: 'Lead',
  contract: 'Pratiche',
  supplypoint: 'Punti di fornitura',
  document: 'Documenti',
  company: 'Aziende',
  invoice: 'Fatture',
  batch: 'Lotti',
  movement: 'Movimenti',
}

export const searchIndexApi = {
  status: () => api<SearchIndexStatus>('/api/platform/search-index'),
  rebuild: () => api<SearchIndexRebuildResult>('/api/platform/search-index/rebuild', { method: 'POST' }),
}
